import { isPopulatedArray } from "@intentsify/utils";
import { ColumnDef } from "@tanstack/react-table";
import { Table } from "components";
import { useMemo } from "react";
import { useAtomValue } from "jotai";
import { useComponentColors } from "theme";
import { topTrendingDomainsStateSelector } from "../../TopTrendingAccounts.state";
import { TopTrendingDomainsWithTimeseriesResponse } from "../../TopTrendingAccounts.types";
import { getColumns } from "./TopTrendingDomainsTable.columns";

type TopTrendingDomainsTableProps = {
  data: TopTrendingDomainsWithTimeseriesResponse | undefined;
  isLoading: boolean;
};

const TopTrendingDomainsTable = ({
  data,
  isLoading,
}: TopTrendingDomainsTableProps) => {
  const { selectedDomains } = useAtomValue(topTrendingDomainsStateSelector);

  const {
    form: { stackBg },
  } = useComponentColors();

  const columns = useMemo<ColumnDef<any>[]>(
    () => (data ? getColumns(data?.timeseries) : []),
    [data]
  );

  const tableData = data ? data.data : [];

  return (
    <Table
      stretch={true}
      noDataMessage={
        !isPopulatedArray(selectedDomains) ? "No data found" : undefined
      }
      bg={stackBg}
      columns={columns}
      isFetching={isLoading}
      data={tableData}
      onFetchDataChange={() => undefined}
    />
  );
};

export { TopTrendingDomainsTable };
